export enum ItemTypesEnum {
  GOODS_FOR_SALES = 0,
  SERVICES = 1,
  MENU_ITEM = 2,
  SUPPLIES = 3,
  BUNDLE_DEALS = 4,
}

export enum DiscountTypesEnum {
  ENTIRE_BILL = 0,
  ITEM_BASED = 1,
  PURCHASE_DEALS = 2,
}

export enum DiscountRateTypesEnum {
  AMOUNT = 0,
  PERCENT = 1,
}

export enum DiscountRuleTypesEnum {
  BUY_GET_FREE = 0,
  BUY_GET_DISCOUNT = 1,
}

export enum ModifierTypesEnum {
  NON_INVENTORY_ITEM = 0,
  INVENTORY_ITEM = 1,
  MODIFIER_GROUP = 2,
}

export enum ItemPriceTypeEnum {
  ALL_SALES_TYPES = 0,
  SPECIFIC_SALES_TYPES = 1,
}
